/*
 * Copyright (c) 2023 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import React from "react";
import "./Footer.scss";
import LanguageSelector from "../../common/LanguageSelector/LanguageSelector";

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <LanguageSelector />
      </div>
    </footer>
  );
};
